import archiver from '../Archiver';
import { archiverUrl, fetchWithAuthorization } from '../../helpers/utils';

const SqlApi = {
    // Axios-based (archiver) — returns { data: [] }
    getStatistic: (variant: string, timeRangeQS: string, instanceId: number, instanceType: string, params: string = '') =>
        archiver.get(`/rest/v2/sql/statistic/${variant}?${timeRangeQS}&id=${instanceId}&type=${instanceType}${params}`),

    // Fetch-based — returns Promise<Response> for use with fetchResults()
    fetchStatistic: (variant: string, timeRangeQS: string, instanceId: number, instanceType: string, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(2)}/sql/statistic/${variant}?${timeRangeQS}&id=${instanceId}&type=${instanceType}${params}`),

    fetchStatisticTime: (timeRangeQS: string, instanceId: number, instanceType: string, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(2)}/sql/statistic/time?${timeRangeQS}&id=${instanceId}&type=${instanceType}${params}`),

    fetchStatisticSql: (timeRangeQS: string, instanceId: number, instanceType: string, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(2)}/sql/statistic/sql?${timeRangeQS}&id=${instanceId}&type=${instanceType}${params}`),

    fetchStatisticGroup: (timeRangeQS: string, instanceId: number, instanceType: string, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(2)}/sql/statistic/group?${timeRangeQS}&id=${instanceId}&type=${instanceType}${params}`),

    fetchStatisticName:(instanceType: string, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(1)}/sql/statistic/name?type=${instanceType}${params}`),

    fetchTagName: (instanceId: number, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(1)}/sql/tag/name?id=${instanceId}${params}`),

    fetchStatisticTagValue: (tagName: string, timeRangeQS: string, instanceId: number, instanceType: string, params: string = ''): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl(1)}/sql/statistic/tag/value?tagname=${tagName}&${timeRangeQS}&id=${instanceId}&type=${instanceType}${params}`),

    fetchTypes: (): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/sql/statistic/type`),

    fetchTypesByInstance: (instanceId: string): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/sql/statistic/type?type=${instanceId}`),
};

export default SqlApi;
